<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-mission-success"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base" v-if="isSuccessAll">
                <div class="modal-base-head">
                    <div class="icon-close" @click="clickClose()">
                        <img src="@/assets/icon/icon_close_modal.svg">
                    </div>
                    <div class="icon-check">
                        <img class="img-fluid" src="@/assets/icon/icon_success.svg">
                    </div>
                    
                    <div class="text-mission-success">{{localePage.text_success}}</div>
                    <div class="text-mission-get">{{localePage.text_get}}</div>
                    <div class="receive-point text-center">
                        <span class="mr-2 point text-bold">{{point | number_format}}</span>
                        <span>
                            <img src="@/assets/icon/reward_icon_coin@3x.png" />
                        </span>
                    </div>

                    <div class="text-desc">{{lbl.mission.detail.success_checkin.day7mission}}</div>
                    <div class="new-game" v-html="lbl.mission.detail.success_checkin.do_mission_next_day"></div>
                </div>
                <div class="modal-base-footer"> 
                    <div class="btn-cancel">
                        <div class="btn-txt" @click="clickToPage()">
                           {{lbl.mission.detail.success_checkin.other_mission}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-base" v-if="!isSuccessAll">
                <div class="modal-base-head">
                    <div class="icon-close" @click="clickClose()">
                        <img src="@/assets/icon/icon_close_modal.svg">
                    </div>
                    <div class="icon-check">
                        <img class="img-fluid" src="@/assets/icon/icon_success.svg">
                    </div>
                    
                    <div class="text-mission-success">{{lbl.mission.detail.success_checkin.success_one_header}}</div>
                    <div class="text-mission-get" v-html="lbl.mission.detail.success_checkin.success_one_desc"></div>  
                </div> 
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
/**
 * @property {String} modalId (reqquired)
 */
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "MissionCheckinSuccessModal",
    props: {
        controller: Object,
        modalId: String
    },
    components: {},
    mixins: [LocaleMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            point: "",
            isSuccessAll: false,
            busModal: null,
            localePage: {},
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.localePage = this.lbl.mission.detail.update_profile.success;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        clickClose: function() {
            this.hide(); 
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickToPage: function(){
            this.hide();
            this.controller.sendCallbackPage({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.point = config.point;
            this.isSuccessAll = config.isSuccessAll;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
             
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import '@/style/input/BaseButton.scss';
.modal-mission-success{
    .modal-base-head{
        .icon-check{
            padding: 10px 0;
            img{
                width: 62px;
            }
        }
        
        .icon-close {
            position: absolute;
            top: 22px;
            right: 22px;
            img {
                width: 20px;
                height: 20px;
            }
        }
        .text-mission-success{
            color: $green;
            font-size: 1.25rem;
            padding: 18px 0 20px 0; 
        }
        .text-mission-get{
            color: $bright-gray;
            font-size: 1.25rem;
        }
        .receive-point {
            margin-top: 10px;
            .point {
                color: $pink;
                font-size: 1.8rem;

                @include mini-mobile(){
                    font-size: 1.5rem;
                }
            }
            img {
                margin-top: -10px;
                width: 40px;
                border-radius: 50%;
                box-shadow: $box-shadow;
                border: 1px solid $border-gray;
            }
        }
        .text-desc { 
            font-size: 1.25rem;
            padding: 22px 0 28px 0;
        }
        .new-game {
            font-size: 1.15rem;
            padding: 0 0 -2px 0; 
            font-family: "Regular";
        }
    }
    .modal-base-footer {
        margin-bottom: 10px;
        .btn-ok{
            @include btn-wrapper();
            margin-top: 30px;
        }

        .btn-cancel{
            @include btn-wrapper($bg-color: $white, $text-color: $blue-gray);
            border: solid 2px $blue-gray;
            margin-top: 15px;
        }
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";

.modal-mission-success {
    .modal-body {
        padding: 25px;

        @include mini-mobile(){
            padding: 10px;
        }

        .modal-base-head{
            font-family: $medium;
            text-align: center;
        }
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin: 0;

        .modal-content {
            box-shadow: $box-shadow-bar;
            border-radius: 0;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            border: 0;
        }
    }

}
</style>
